import React, { Component } from 'react'
import moment from 'moment';
import { GenericTable } from '../index';


const headers = [
    { title: "Código" },
    { title: "Nombre" },
    { title: "Fecha" },
    { title: "Valor" },
    { title: "Estatus" },
    { title: "ACCIONES" },
    { title: "ACCIONES" },
];

class RequestAmbassadors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDateParam: -1
            , toDateParam: moment().format("YYYY-MM-DD")
            , data: []
        };
    }

    ChangeStateField = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    render() {
        return (
            <>
                <div className="row">
                    <div className="col-12 h5"> <i className="fas fa-filter mr-2" /> Filtros de búsqueda </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <label htmlFor="iDateFrom" className="input-group-text font-weight-bold"> Desde </label>
                            </div>
                            <input
                                id="iDateFrom"
                                className="form-control"
                                type="date"
                                value={this.state.toDateParam ?? new Date()}
                                onChange={({ target: { value } }) => this.ChangeStateField("toDateParam", value)} />
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 col-xl-4 mb-3">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <label htmlFor="iDateFrom" className="input-group-text font-weight-bold"> Hasta </label>
                            </div>
                            <input
                                id="iDateFrom"
                                className="form-control"
                                type="date"
                                value={this.state.toDateParam ?? new Date()}
                                onChange={({ target: { value } }) => this.ChangeStateField("toDateParam", value)} />
                        </div>
                    </div>


                    <div className="col-auto">
                        <button className="btn btn-outline-dark" title="Actualizar" onClick={() => { }} > <i className="fa fa-refresh" /> </button>
                    </div>
                </div>

                <div className="">
                    <GenericTable
                        headers={headers}
                        data={this.state.data}
                        view={'requestAmbassadors'}
                        enableSearchInTable={true}
                        action={this.OpenBusinessPartnerDetails}
                    />
                </div>


            </>
        )
    }
}

export default RequestAmbassadors